import type { ServiceCategory, ServiceDoc } from '@makhe/shared';

export interface LandingShowcase {
  id: string;
  sellerName: string;
  title: string;
  category: ServiceCategory;
  priceZARcents: number;
  rating: number;
  reviews: number;
  img?: string;
  video?: string;
}

/** Spotlight first, then real ratings. Never invent a 5.0. */
export function pickLandingServices(docs: ServiceDoc[], take = 4): ServiceDoc[] {
  const bySeller = new Map<string, ServiceDoc>();
  for (const s of docs) {
    const cur = bySeller.get(s.sellerId);
    if (!cur || (s.spotlight && !cur.spotlight)) bySeller.set(s.sellerId, s);
  }
  return [...bySeller.values()]
    .sort(
      (a, b) =>
        Number(Boolean(b.spotlight)) - Number(Boolean(a.spotlight)) ||
        (b.stats?.averageRating || 0) - (a.stats?.averageRating || 0),
    )
    .slice(0, take);
}

export function serviceToShowcase(s: ServiceDoc): LandingShowcase {
  const prices = s.pricingTiers.map((t) => t.priceZARcents);
  const cover =
    s.media.coverImageURL || s.media.videoThumbnailURL || s.media.photoURLs?.[0] || '';
  return {
    id: s.id,
    sellerName: s.sellerSnapshot.displayName,
    title: s.title,
    category: s.category,
    priceZARcents: prices.length ? Math.min(...prices) : 0,
    rating: s.stats?.averageRating || s.sellerSnapshot.averageRating || 0,
    reviews: s.stats?.totalReviews || s.sellerSnapshot.totalReviews || 0,
    img: cover || undefined,
    video: cover ? undefined : s.media.videoURL,
  };
}
